
<template>
  <v-app>
    <main-app-bar elevation="2" app-bar-color="" app-bar-text-color="">
    </main-app-bar>
    <v-main class="mainDiv" v-bind:style="{ 'background-image': 'url(' + baseImg + ')' }">
      <div style="position: absolute; top: 65px; left: 0; right: 0; bottom: 10px; overflow-y: scroll">
        <section class="mt-5">
          <v-row class="mx-auto" align="center" justify="center">
            <v-col lg="8" xs="12">
              <v-card style="background-color: #ffffffa0">
                <h1 class="queensFont" style="text-align: center">Lépj velünk kapcsolatba!</h1>
                <v-container fluid>
                  <connection-row></connection-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </section>
        <section>
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col lg="8" xs="12">
                <v-card>
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1626.1723109460793!2d19.866653731243492!3d46.72773102185655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4743e9006da49731%3A0xce556a9025c7c1cb!2zS3JlYXTDrXYgSMOtbXrFkWt1Y2vDsw!5e0!3m2!1shu!2shu!4v1734196153637!5m2!1shu!2shu" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </v-card>
              </v-col>
            </v-row>

          </v-container>
        </section>
      </div>
    </v-main>

  </v-app>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import MainAppBar from "@/components/MainAppBar.vue";
import ConnectionRow from "@/components/ConnectionRow.vue";

@Options({
  components: {ConnectionRow, MainAppBar},
  data() {
    return {
      drawer: false,
      baseImg: require("@/assets/base.png"),
    };
  },
  methods: {
    onAboutClick(): void {
      this.$router.push("company");
    },
  }
})
export default class ConnectionView extends Vue {

}
</script>


<style scoped>
.mainDiv {
  background-repeat: no-repeat;
  /*background-attachment: fixed;*/
  background-size: cover;
  background-position: 100% 100%;
}
</style>